import { render, staticRenderFns } from "./InquiryForm.vue?vue&type=template&id=63819a5a&scoped=true&"
import script from "./InquiryForm.vue?vue&type=script&lang=ts&"
export * from "./InquiryForm.vue?vue&type=script&lang=ts&"
import style0 from "./InquiryForm.vue?vue&type=style&index=0&id=63819a5a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "63819a5a",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VSimpleTable } from 'vuetify/lib/components/VDataTable';
import { VSubheader } from 'vuetify/lib/components/VSubheader';
installComponents(component, {VBtn,VCol,VContainer,VRow,VSimpleTable,VSubheader})
